

function isTeamHealthAvailable(tier) {
  return tier !== 'starter'
}

export default isTeamHealthAvailable
